import React, { useEffect } from 'react'
import Button from '../Button';

interface Props {
    autoCompleteOnRender?: boolean;
    children?: React.ReactNode;
    isLastLesson?: boolean;
    onCompleted?: () => void;
    onGoToNextLesson?: () => void;
    onGoToChaptersView?: () => void;
}

export const LessonWrapper = (props: Props) => {

    useEffect(() => {
        if (props.autoCompleteOnRender === true && props.onCompleted !== undefined)
            props.onCompleted();
    }, [props.autoCompleteOnRender, props.onCompleted]);

    return (
        <div className='space-y-6'>
            {props.children}
            <div className='sticky bottom-0 bg-gradient-to-t from-[#30B0EA] p-4'>
                {props.isLastLesson === true ? (
                    <div
                        onClick={() => {
                            if (props.onGoToChaptersView !== undefined) props.onGoToChaptersView();
                        }}
                        className='p-5 text-[0.9em] font-bold text-white bg-[#1450db] cursor-pointer select-none text-center rounded-[10px]'>
                        Volver a los capítulos
                    </div>
                ) : (
                    <div
                        onClick={() => {
                            if (props.onGoToNextLesson !== undefined) props.onGoToNextLesson();
                        }}
                        className='p-5 text-[0.9em] font-bold text-white bg-[#1450db] cursor-pointer select-none text-center rounded-[10px]'>
                        Ir al siguiente ejercicio
                    </div>
                )}
            </div>
        </div>
    );
};